"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'user.form.userGroup.label': 'Grupo de Usuarios',
    'user.form.userGroup.placeholder': 'Seleccionar grupo de usuarios',
    'user.form.userGroup.show': 'Mostrar Grupos de Usuarios',
    'user.form.userGroup.add': 'Agregar nuevo grupo de usuarios',
    'user.form.userGroup.search_placeholder': 'Buscar grupos de usuarios...',
    'user.form.title.edit': 'Editar Usuario',
    'user.form.title.add': 'Añadir Usuario',
    'user.form.back': 'Volver',
    'user.form.name.label': 'Nombre',
    'user.form.name.placeholder': 'Juan',
    'user.form.last_name.label': 'Apellido',
    'user.form.last_name.placeholder': 'Pérez',
    'user.form.username.label': 'Login',
    'user.form.username.placeholder': 'juanperez',
    'user.form.email.label': 'Correo Electrónico',
    'user.form.email.placeholder': 'correo@direccion.com',
    'user.form.password.label': 'Contraseña',
    'user.form.password.new.label': 'Nueva Contraseña (dejar vacío para mantener actual)',
    'user.form.password.placeholder': 'Contraseña',
    'user.form.password.repeat.label': 'Repetir Contraseña',
    'user.form.password.repeat.new.label': 'Repetir Contraseña (dejar vacío para mantener actual)',
    'user.form.password.repeat.placeholder': 'Repetir Contraseña',
    'user.form.role.label': 'Rol',
    'user.form.role.placeholder': 'Seleccionar rol',
    'user.form.active.label': 'Activo',
    'user.form.companies.label': 'Empresas asignadas',
    'user.form.companies.placeholder': 'Seleccionar empresas',
    'user.form.company.label': 'Empresa',
    'user.form.company.placeholder': 'Seleccionar una empresa...',
    'user.form.submit.update': 'Actualizar Usuario',
    'user.form.submit.create': 'Crear Usuario',
    'user.form.acl.loadError': 'Error al cargar metadatos ACL:',
    'user.form.load.debug': 'Cargando usuario:',
    'user.form.load.error': 'Error al cargar usuario',
    'user.form.submit.updateError': 'Error al actualizar usuario',
    'user.form.submit.createError': 'Error al crear usuario',
    'user.form.submit.updateSuccess': 'Usuario actualizado exitosamente',
    'user.form.submit.createSuccess': 'Usuario creado exitosamente',
    'user.form.preview.title': 'Vista Previa de Acceso',
    'user.form.preview.selectedGroup': 'Grupo Seleccionado',
    'user.form.preview.permissions': 'Permisos',
    'user.form.preview.selectGroup': 'Selecciona un grupo de usuarios para ver los permisos de acceso',
    'user.form.preview.noAccess': 'No hay permisos de acceso disponibles',
    'user.form.error.userGroup_required': 'La selección de grupo de usuarios es requerida',
};
